import { useQuery } from '@tanstack/react-query';
import { channelCategoriesQueryOptions } from '../../../hooks/useChannelCategories';
import LiveTVChannels from './elements/LiveTVChannels';
import MoodCategory from './elements/MoodCategory';

const LiveTV = ({ mood, onChangeMood }) => {
    const { data: categories = [], isLoading: loading } = useQuery(channelCategoriesQueryOptions(mood));

    return (
        <MoodCategory
            mood={mood}
            onChangeMood={onChangeMood}
            Component={LiveTVChannels}
            titleKey={mood?.title_resource_key || 'mood_recommendation_categories_title'}
            getCategories={() => categories}
            loading={loading}
        />
    );
};

export default LiveTV;
